let timezoneDataPromise;

export class TimeZoneService {
	/**
	 * Save injections
	 * @param {ApiProvider} Api
	 */
	constructor(Api) {
		'ngInject';
		this.Api = Api;
	}

	/**
	 * Get a list of timezones from /api/v2/timezones
	 * @return {Promise<Object[]>}  Each item in the resolved data has properies:
	 * @property {String} id  The canonical identifier such as "America/New_York"
	 * @property {Number} offset  Offset from UTC in minutes
	 * @property {Number} in_dst  1 if currently in daylight savings, 0 if not
	 * @property {String} name  The user-label such as "-05:00 America/New York"
	 */
	getData() {
		if (!timezoneDataPromise) {
			timezoneDataPromise = this.Api.get('/timezones');
		}
		return timezoneDataPromise;
	}

	/**
	 * Get details on the user's timezone, falling back to details from "America/New_York"
	 * @return {Object}
	 * @property {Boolean} guess  True if TZ could not be obtained through Intl
	 * @property {Number} offset  The current offset in minutes
	 * @property {String} id  The timezone identifier (e.g. "America/Denver")
	 * @property {String} name  The timezone identifier with underscores changed to spaces (e.g. "America/New York")
	 */
	getUserTimezone() {
		const now = new Date();
		const tz = {
			guess: false,
			offset: now.getTimezoneOffset(),
		};
		try {
			// IE11+ support Intl
			// However, on IE11, timeZone is not set
			tz.id = Intl.DateTimeFormat().resolvedOptions().timeZone;
		} catch (e) {
			// No support for Intl: IE 10 or lower
		}
		if (!tz.id) {
			// IE or old browsers
			const guesses = {
				Hawaii: 'Pacific/Honolulu',
				Alaska: 'America/Anchorage',
				Pacific: 'America/Los_Angeles',
				Central: 'America/Chicago',
				Mountain: 'America/Denver',
				Eastern: 'America/New_York',
			};
			const name = String(now).match(/^(.+) (Daylight|Standard) Time/)[1];
			if (guesses[name]) {
				tz.id = guesses[name];
				tz.guess = true;
			}
		}
		if (!tz.id) {
			tz.id = 'America/New_York';
			tz.guess = true;
		}
		tz.name = tz.id.replace(/_/g, ' ');
		return tz;
	}
}
